module.exports = __webpack_public_path__ + "static/media/contact-map.ff140a52.png";